namespace advisorop.components.widgets {
    
    export class TopHouseholdsController{
        n: number;        
        public model: domains.IChartDataSource;
        public dg;
        public asOfDate;
        adminMode: domains.IAdminMode;

        constructor(private advisorService: services.AdvisorService, private $rootScope: ng.IRootScopeService) {                        
            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                //reload households ...
                this.loadTopNHouseholds();
            });
            this.dg = {
                export: {
                    enabled: true,
                    fileName: "TopHouseHolds"
                },
                bindingOptions: {
                    dataSource: "vm.model.data"
                },
                //height: "350px",
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                stateStoring: {
                    enabled: false,
                    type: "localStorage",
                    storageKey: "dgTOPNHouseholds"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },
                //selection: {
                //    mode: "single"
                //},
                columns: [
                    { dataField: 'label', caption: 'Household name', cellTemplate: 'colFullName'},
                    { dataField: 'value', caption: 'USD Value', width: 110, format: { type: 'fixedPoint', precision: 2 } }                    
                ],
                //onRowClick: (e) => {
                //    const data: {
                //        bySecurityTypes: string, id: number, label: string, label2: string
                //        value: number, value2: number, value3: number
                //    } = e.data;

                //    console.log(`Row has been clicked ...`, data.id);
                //}
            };            
        }

        loadTopNHouseholds(): void
        {
            this.adminMode = this.advisorService.getAdminMode();
            const adminModeEnabled = this.adminMode && this.adminMode.enabled;
            var promise: ng.IHttpPromise<domains.IChartDataSource>;
            if (this.adminMode && this.adminMode.enabled) {
                promise = this.advisorService.getTopNHouseholds(adminModeEnabled, this.n, (adminModeEnabled && this.adminMode.advisoryFirm) ? this.adminMode.advisoryFirm.id : null);
            } else {
                promise = this.advisorService.getTopNHouseholds(adminModeEnabled, this.n);
            }

            promise.then(data => {
                this.model = data.data;
                this.asOfDate = this.model.asOfDt;
            }).catch(data => {
                toastr.error("TOP N Households error: " + data.status + ":" + data.data);
            });
        }

        $onInit(): void {
            // initialise only if n is undefined
            if (!this.n) {
                // console.log(`Loading TopNHouseholds OnInit`);
                this.loadTopNHouseholds();
            }
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "n") {
                    if (this.n) {
                        // console.log(`Loading TopNHouseholds OnChange`);
                        this.loadTopNHouseholds();
                    }
                }
            }
        }

        $routerOnActivate(next, previous) {
            
        }        

    }



    class TopHouseholds implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                n: "<",
                asOfDate: "="
            };
            this.controller = ["advisorService", "$rootScope", TopHouseholdsController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/top-households.html';            
        }
    }
    angular.module(Constants.APP).component("topHouseholds", new TopHouseholds());
    
}